import {
    loanOptionDefault,
    loanOptionDefaultAEM,
    LoanOptionState,
} from './loanOptionTypes';
import { ApiStatus } from '../../types';
export const initialStateLoanOption: LoanOptionState = {
    content: loanOptionDefaultAEM,
    loanOptionData: loanOptionDefault,
    loanOptionFormDetail: {
        minAmount: 4000,
        loanAmount: 0,
        maxAmount: 100000,
        loanTermYear: 0,
        repaymentFrequency: 'Weekly',
    },
    updateLoanOptionFormDetailRequest: {
        loanAmount: 0,
        loanTermYear: 0,
    },
    getLoanOptionApiStatus: ApiStatus.Idle,
    updateLoanOptionFormDetailApiStatus: ApiStatus.Idle,
    apiEndpoints: {
        getLoanOptionApiUrl: '/getLoanOptions',
        updateLoanOptionFormDetailApiUrl: '/updateLoanOptionsForm',
    },
};
